import { GatsbyBrowser } from 'gatsby';
import { getCookie } from '@lucid/utils';

const onClientEntry: GatsbyBrowser['onClientEntry'] = async () => {
  try {
    if (typeof IntersectionObserver === 'undefined') {
      // @ts-ignore
      await import('intersection-observer');
    }

    const preloadChart = document.createElement('iframe');
    preloadChart.style.display = 'none';
    preloadChart.src = 'https://app.lucidchart.com/documents/preloadChart';

    const preloadChartNewDomain = document.createElement('iframe');
    preloadChartNewDomain.style.display = 'none';
    preloadChartNewDomain.src = 'https://lucid.app/documents/preloadChart';

    const loadPreloadScripts = () => {
      document.getElementsByTagName('body')[0].appendChild(preloadChart);
      document.getElementsByTagName('body')[0].appendChild(preloadChartNewDomain);
      window.removeEventListener('scroll', loadPreloadScripts);
    };
    window.addEventListener('scroll', loadPreloadScripts);
  } catch (error) {
    console.error(`onClientEntry: ${error}`);
  }
};

const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  const { href, search, pathname } = window.location;
  if (window.ga) {
    const userId = getCookie('userId');
    const initialLandingPage = getCookie('initialLandingPage') || undefined;
    const ltAnonymousId = getCookie('lt-anonymous-id') || undefined;

    if (userId) {
      window.ga('set', 'userId', userId);
    }

    window.ga('set', 'location', href);
    window.ga('set', 'page', `${pathname}${search}`);
    window.ga('set', 'dimension1', search || 'undefined');
    window.ga('set', 'dimension2', initialLandingPage  || 'undefined');
    window.ga('set', 'dimension3', ltAnonymousId || 'undefined');
  }

  if (window.dataLayer) {
    window.dataLayer.push({ 'originalLocation': href });
  }

  if (search.includes('showEditLink=1')) {
    window.localStorage.setItem('showEditLink', '1');
  }
};

const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ prevLocation }) => {
  let { pathname } = window.location;
  if (pathname === '/' || pathname === 'pages/') {
    pathname = 'homepage';
  }

  if (
    prevLocation &&
    !(prevLocation as Location).pathname.includes('/contact/')
  ) {
    // set session storage so we can use it on single page marketo form
    try {
      sessionStorage.setItem(
        'previousPageviewId',
        getCookie('lt-pageview-id') || ''
      );
      sessionStorage.setItem(
        'prevLocation',
        (prevLocation as Location).pathname
      );
    } catch {
      // no-op
    }
  }
};

export {
  onClientEntry,
  onRouteUpdate,
  onInitialClientRender,
};
